<template>
<div class="about">
  <v-layout row>
    <v-flex md12>
      <v-card :disabled="btnLoad" flat class="mb-2">
        <v-card-title>
          Retatório de dados
        </v-card-title>
        <v-layout row class="mx-2">
          <v-flex md4 class="pr-1" v-if="filtro.filtros.includes('empresa')">
            <v-autocomplete standard label="Empresas" v-model="empresa" :items="empresas" @change="listarUnidades" return-object item-text="nomeFantasia"></v-autocomplete>
          </v-flex>
          <v-flex md4 class="pr-1" v-if="filtro.filtros.includes('unidadesDeProcessamento')">
            <v-autocomplete standard label="Unidades de Processamento" v-model="unidadeProcessamento" :items="unidadesProcessamento" @change="listarUnidades" return-object item-text="nome"></v-autocomplete>
          </v-flex>
          <!-- <v-flex md4 class="pl-1 pr-1" v-if="filtro.filtros.includes('multiUnidades')">
            <v-autocomplete :disabled="empresa.id == 0 || multiUnidades.length > 10" multiple v-model="multiUnidades" label="Unidades" :items="unidades" item-text="nome" item-value="id">
              <template v-slot:prepend-item>
                <v-list-item ripple @click="selecionarUnidades">
                  <v-list-item-action>
                    <v-icon :color="multiUnidades.length > 0 ? 'accent' : ''">{{icon}}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>MARCAR TODOS</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template v-slot:selection="{ item, index }">
                <div v-if="index === 0">
                  <span>{{ item.nome }}</span>
                </div>
                <span v-if="index === 1" class="grey--text caption">(+{{ multiUnidades.length - 1 }} outros)</span>
              </template>
            </v-autocomplete>
          </v-flex> -->
          <v-flex md4 class="pl-1 pr-1" v-if="filtro.filtros.includes('unidade')">
            <v-autocomplete standard v-model="unidade" label="Unidades" :items="unidades" return-object item-text="nome"></v-autocomplete>
          </v-flex>
          <v-flex md4 class="pl-1 pr-1" v-if="filtro.filtros.includes('convenio')">
            <v-autocomplete multiple v-model="multiConvenios" label="Convenios" :items="convenios" item-text="nome" item-value="id"></v-autocomplete>
          </v-flex>
          <v-flex md4>
           <dateForm :data="filtro" @dataInicio="save" @dataFim="saveEnd"></dateForm>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-radio-group v-if="filtro.isPublicoPrivado" :disabled="!dateEnd" row v-model="radios" :mandatory="false">
            <v-radio label="Listar todas" :value="2"></v-radio>
            <v-radio label="Publico" :value="0"></v-radio>
            <v-radio label="Privado" :value="1"></v-radio>
          </v-radio-group>
          <v-spacer></v-spacer>
          <v-btn color="warning" @click.stop="limparDados()" text>
            Limpar
          </v-btn>
          <v-btn :loading="btnLoad" :disabled="dateEnd == null" class="ma-2" color="primary" @click="carregarDados()">
            <v-icon left>search</v-icon> Buscar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import service from './../services/userservice'
import dateForm from './dateForm'
import {
  EventBus
} from './../main'

export default {
  name: 'filtro',
  components: {
    dateForm
  },
  data () {
    return {
      date: null,
      radios: 2,
      empresas: [],
      empresa: null,
      minDate: '',
      btnLoad: 0,
      params: {},
      dateEnd: null,
      filtro: null,
      unidades: [],
      idEmpresa: 0,
      multiUnidades: [],
      isUnidade: false,
      erroDate: '',
      unidadesProcessamento: [],
      unidadeProcessamento: {
        idCidade: 0,
        idUnidadeNegocio: 0,
        idUnidadeProcessamento: 0
      },
      unidade: null,
      load: false
    }
  },
  computed: {
    icon () {
      if (this.multiUnidades.length === this.unidades.length) return 'mdi-close-box'
      if (this.multiUnidades.length > 0) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  watch: {
    unidadeProcessamento (val) {
      this.isUnidade = false
    },
    unidade (val) {
      this.isUnidade = false
    }
  },
  methods: {
    selecionarUnidades () {
      this.$nextTick(() => {
        if (this.multiUnidades.length > 0) {
          this.multiUnidades = []
        } else {
          this.multiUnidades = this.unidades.slice()
        }
      })
    },
    carregarDados () {
      this.isMsg = false
      this.btnLoad = 0
      this.erroDate = null
      if (this.unidade == null) {
        this.unidade = {
          id: 0,
          idUnidadeProcessamento: 0
        }
      }
      var dInicio = new Date(this.date)
      var dFim = new Date(this.dateEnd)
      if (dInicio <= dFim) {
        // EventBus.$emit('loadStop', 1)
        this.$emit('carregar-dados', {
          tipoConvenio: this.radios,
          dataInicio: dInicio,
          dataFim: dFim,
          idCidadeProcessamento: this.unidadeProcessamento.idCidade,
          idUnidadeProcessamento: this.unidadeProcessamento.idUnidadeProcessamento,
          idsUnidades: this.multiUnidades,
          idEmpesa: this.idEmpresa,
          idUnidadeNegocio: this.unidade.id
        })
      } else {
        this.erroDate = 'Erro na escolha da data.'
      }
    },
    limparDados () {
      EventBus.$emit('limpar-dados')
      this.unidade = null
      this.empresa = null
      this.multiUnidades = []
      this.multiConvenios = null
      this.unidades = []
      this.unidadeProcessamento = {
        idCidade: 0,
        idUnidadeNegocio: 0,
        idUnidadeProcessamento: 0
      }
      // this.selecionarUnidades()
      this.listarUnidadesProcessamento()
      this.allUnidades()
    },
    save (date) {
      this.date = date
    },
    saveEnd (date) {
      this.dateEnd = date
    },
    listarUnidadesProcessamento () {
      this.load = true
      service.listarUnidadesProcessamento().then(r => {
        this.unidadesProcessamento = r.data
      }).finally(() => {
        this.load = false
      })
    },
    listarEmpresas () {
      this.load = true
      service.listarEmpresas().then(r => {
        this.empresas = r.data
      }).finally(() => {
        this.load = false
      })
    },
    allUnidades () {
      this.load = true
      service.buscarUnidades().then(r => {
        if (r.status === 200) {
          this.mUnidades = r.data
          this.unidades = this.mUnidades
          this.isUnidade = true
        }
      }).finally(r => {
        this.load = false
      })
    },
    // listarConvenios () {
    //   this.load = true
    //   let idEmpresa = 0
    //   if (this.empresa != null) {
    //     idEmpresa = this.empresa.id
    //   }
    //   if (this.unidade)
    // },
    listarUnidades (empresa) {
      this.load = true
      let idUnidadeNegocio = 0
      let idEmpresa = 0
      if (this.empresa != null) {
        idEmpresa = this.empresa.id
        idUnidadeNegocio = 0
        console.log(this.empresa.id)
      } else if (this.unidadeProcessamento != null) {
        idUnidadeNegocio = this.unidadeProcessamento.id
        idEmpresa = this.unidadeProcessamento.idEmpresa
      }
      this.idEmpresa = idEmpresa
      service.listarUnidades({
        idUnidadeNegocio: idUnidadeNegocio,
        idEmpresa: idEmpresa
      }).then(r => {
        if (r.status === 200) {
          this.unidades = r.data
        } else if (r.status === 203) {}
      }).finally(() => {
        this.load = false
      })
    },
    computerBtnLoad (i) {
      this.btnLoad = i
    },
    computerBtnLoadStart (i) {
      this.btnLoad = this.btnLoad + 1
    },
    carregarFiltro (data) {
      if (data == null) {
        this.filtro = this.$cookies.get('filtro')
      } else {
        this.filtro = data
        this.$cookies.set('filtro', data)
      }
    }
  },
  mounted () {
    // this.criarGrafico(this.graficos)
    this.listarEmpresas()
    this.listarUnidadesProcessamento()
    this.allUnidades()
    // EventBus.$on('btnLoadStart', this.computerBtnLoadStart)
    EventBus.$on('load', this.computerBtnLoad)
    EventBus.$on('filtro', this.carregarFiltro)
    if (this.filtro == null) {
      this.carregarFiltro()
    }
  }
}
</script>
